import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SearchDropdownComponent } from '../search-dropdown/search-dropdown.component';
import { PaginationTableComponent } from '../pagination-table/pagination-table.component';
import { NgSelectNullToZeroDirective } from '../../../app/directives/ng-select-null-to-zero.directive';

@NgModule({
  declarations: [
    SearchDropdownComponent,
    PaginationTableComponent,
    NgSelectNullToZeroDirective
  ],
  imports: [
    CommonModule, FormsModule
  ],
  exports: [
    SearchDropdownComponent,
    PaginationTableComponent,
    NgSelectNullToZeroDirective
  ]
})
export class SharedModule { }
